import React from 'react';
import { withRouter } from 'react-router-dom';

import styles from './troy.module.scss';
import { connectTo } from '../../utils';
import {
  getDecisions,
  getCustomers,
  toggleAbsoluteDemandTable,
} from '../../actions';
import { HeaderWithContacts } from '../../components/home-container/index.troy';

import { ABSOLUTE_DEMAND_TABLE_VALUE } from '../../constants/headers';
import { ERROR } from '../../constants/routes';

// const KEY_TAB_NAME = 'troyLastTab';

class HomeContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    // const localTabNumb = Number(localStorage.getItem(KEY_TAB_NAME));
    this.state = {
      value: false,
      // value: localTabNumb || localTabNumb === 0 || false,
      isRedirectCalculated: false,
      isAuthenticated: props.isAuthenticated,
      isHeaderSticky: false,
      headerOffsetTop: 0,
    };
    this.headerRef = React.createRef();
  }

  getUserInfo = () => {
    const { getCustomers, getDecisions, isAuthenticated } = this.props;
    if (isAuthenticated) {
      getDecisions();
      getCustomers();
    }
  };

  componentDidMount() {
    window.addEventListener('popstate', this.onBackClick);
    window.addEventListener('scroll', this.onScroll);

    this.getUserInfo();
  }

  componentDidUpdate(prevProps, prevState) {
    const { token } = this.props;
    if (token && token !== prevProps.token) {
      this.getUserInfo();
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let returnObj = null;
    if (nextProps.isAuthenticated !== prevState.isAuthenticated) {
      const { getDecisions, getCustomers, isAuthenticated } = nextProps;
      if (isAuthenticated) {
        getDecisions();
        getCustomers();
      }
      returnObj = { isAuthenticated };
    }
    if (
      !prevState.isRedirectCalculated &&
      nextProps.headerList &&
      nextProps.mobileHeaderList
    ) {
      const tabSet = new Set(nextProps.headerList);
      nextProps.mobileHeaderList.forEach((value) => tabSet.add(value));

      const commonTabArray = Array.from(tabSet);
      const {
        location: { pathname: location },
      } = nextProps;

      const tabOnPath = commonTabArray.find(
        ({ route, value }) =>
          location === route && value !== ABSOLUTE_DEMAND_TABLE_VALUE
      );

      returnObj = returnObj
        ? {
            ...returnObj,
            value: tabOnPath ? tabOnPath.value : false,
            isRedirectCalculated: true,
          }
        : {
            value: tabOnPath ? tabOnPath.value : false,
            isRedirectCalculated: true,
          };
    }
    return returnObj;
  }

  onBackClick = (e) => {
    const { location, headerList, mobileHeaderList } = this.props;
    let list = [];
    if (headerList && mobileHeaderList) {
      list = [...headerList];
      mobileHeaderList.forEach((mobileElem) => {
        const found = headerList.find(
          (elem) => elem.value === mobileElem.value
        );
        if (!found) {
          list.push(mobileElem);
        }
      });
    } else if (headerList || mobileHeaderList) {
      list = headerList || mobileHeaderList;
    }
    const prevTab = list.find(({ route }) => route === location.pathname);

    let value = false;
    if (prevTab) {
      value = prevTab.value;
    }
    this.setState({ value });
    // localStorage.setItem(KEY_TAB_NAME, value);
  };

  onScroll = () => {
    const domElement = this.headerRef.current;
    if (domElement) {
      if (
        window.pageYOffset > domElement.offsetTop &&
        window.pageYOffset > this.state.headerOffsetTop
      ) {
        if (!this.state.isHeaderSticky) {
          this.setState({
            isHeaderSticky: true,
            headerOffsetTop: domElement.offsetTop,
          });
        }
      } else if (this.state.isHeaderSticky) {
        this.setState({ isHeaderSticky: false, headerOffsetTop: 0 });
      }
    }
  };

  onTabChange = (event, value) => {
    const {
      toggleAbsoluteDemandTable,
      headerList,
      mobileHeaderList,
    } = this.props;

    if (headerList || mobileHeaderList) {
      if (value === ABSOLUTE_DEMAND_TABLE_VALUE) {
        toggleAbsoluteDemandTable(false);
      } else {
        toggleAbsoluteDemandTable(true);
      }

      this.setState({
        value,
      });
      // localStorage.setItem(KEY_TAB_NAME, value);
    }
  };

  onLogoClick = () => {
    const { toggleAbsoluteDemandTable, absoluteDemandTableHide } = this.props;
    this.setState({
      value: false,
    });
    if (!absoluteDemandTableHide) {
      toggleAbsoluteDemandTable(true);
    }
    // localStorage.setItem(KEY_TAB_NAME, false);
  };

  render() {
    const { children, headerList, mobileHeaderList, location } = this.props;
    const { value, isHeaderSticky } = this.state;
    const { onTabChange, onLogoClick, headerRef } = this;

    return (
      <div className={styles['home-container__wrapper']}>
        <HeaderWithContacts
          {...{ onTabChange, onLogoClick, value }}
          tabs={headerList || []}
          mobileTabs={mobileHeaderList || []}
          ref={headerRef}
          isSticky={isHeaderSticky}
          currentRoute={location.pathname}
        />
        <div
          className={styles['home-container__children']}
          style={
            isHeaderSticky
              ? { paddingTop: headerRef.current.clientHeight }
              : undefined
          }
        >
          <div className={styles['home-container__children-content']}>
            {children}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connectTo(
    ({
      auth: { token },
      ui: {
        home: {
          headerList,
          mobileHeaderList,
          hide: { absoluteDemandTable },
        },
      },
    }) => ({
      token,
      headerList,
      mobileHeaderList,
      absoluteDemandTableHide: absoluteDemandTable,
    }),
    {
      getDecisions,
      getCustomers,
      toggleAbsoluteDemandTable,
    },
    HomeContainer
  )
);
